import {
  Wallet,
  Settings,
  History,
  TrendingUp,
  type LucideIcon
} from 'lucide-react'
import { IconButton } from '@radix-ui/themes'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

type NavItem = {
  path: string
  icon: LucideIcon
  labelKey: string
}

const navItems: NavItem[] = [
  { path: '/dashboard', icon: Wallet, labelKey: 'sidebar.dashboard' },
  { path: '/history', icon: History, labelKey: 'sidebar.history' },
  { path: '/explorer', icon: TrendingUp, labelKey: 'sidebar.explore' },
  { path: '/settings', icon: Settings, labelKey: 'sidebar.settings' }
]

const NavBar = () => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const navigate = useNavigate()

  return (
    <div className="fixed -bottom-0.5 left-0 z-50 w-full h-16 bg-card border-t border-border-base rounded-t-3xl">
      <div className="grid h-full max-w-lg grid-cols-4 mx-auto font-medium">
        {navItems.map(({ path, icon: Icon, labelKey }) => {
          const isActive = pathname === path
          return (
            <div
              key={path}
              className="h-full py-1 flex flex-col items-center justify-center gap-1"
            >
              <IconButton
                onClick={() => navigate(path)}
                color="gray"
                radius="full"
                variant="ghost"
                size="3"
              >
                <Icon
                  className={`w-5 h-5 ${
                    isActive
                      ? 'icon-gradient-secondary'
                      : 'text-black/50 dark:text-text-secondary'
                  }`}
                />
              </IconButton>
              <span
                className={`text-xs leading-none tracking-widest ${
                  isActive
                    ? 'secondary-gradient-text'
                    : 'text-black/50 dark:text-text-secondary'
                }`}
              >
                {t(labelKey)}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default NavBar
